import React, { useState, useCallback, useRef, useEffect } from 'react';
import './index.scss';
import usePrevious from 'hooks/use-previous';

export interface IModalProps {
    children?: any;
    show: boolean;
    clickModal?: () => void;
    styleSet?: React.CSSProperties;
    className?: string;
}

export default function Modal(props: IModalProps) {
    const modalRef = useRef<HTMLDivElement>(null);
    const [inTransition, setInTransition] = useState(false);
    useEffect(() => {
        // 避免动画过程中，点击界面使弹窗消失
        if (modalRef.current) {
            if (props.show) {
                setInTransition(true);
            }
            const onTransitionEnd = (e: TransitionEvent) => {
                // IOS13抖音中e.propertyName为background
                if (
                    e.target === modalRef.current &&
                    (e.propertyName === 'background-color' || e.propertyName === 'background')
                ) {
                    setInTransition(false);
                }
            };
            // 当出售show为true的时候没有动画会发生bug，这里使用setTimeout保证即使onTransitionEnd不触发也会重置inTransition为false
            const id = setTimeout(() => {
                setInTransition(false);
            }, 400);
            modalRef.current.addEventListener('transitionend', onTransitionEnd);
            return () => {
                if (modalRef.current) {
                    modalRef.current.removeEventListener('transitionend', onTransitionEnd);
                }
                clearTimeout(id);
            };
        }
    }, [props.show]);
    return (
        <div
            ref={modalRef}
            onClick={inTransition ? undefined : props.clickModal}
            className={
                'modal ' +
                (props.show ? 'modal--show' : 'modal--hide') +
                ` ${props.className ? props.className : ''}`
            }
        >
            {props.children}
        </div>
    );
}
